import { gql } from "@apollo/client";
import { TOPIC_BASIC_FIELDS_FRAGMENT } from "../fragments/TopicFragments";

const GET_PAST_CLASSES = gql`
  query GetPastClasses($first: Int, $after: String) {
    pastClasses(first: $first, after: $after) {
      totalCount
      ratedClassCount
      pageInfo {
        endCursor
        startCursor
        hasPreviousPage
        hasNextPage
      }
      nodes {
        id
        date
        time
        classType
        classSize
        category
        seatsRemaining
        completed
        rated
        language {
          id
          englishName
          realName
          bannerBackground
        }
        teacher {
          id
          avatar
          givenName
          familyName
        }
        topic {
          ...TopicBasicFields
        }
        chapter {
          name
        }
        level {
          title
        }
        city {
          id
          name
        }
      }
    }
  }
  ${TOPIC_BASIC_FIELDS_FRAGMENT}
`;

export default GET_PAST_CLASSES;
